const MAX_DIM = 1600;
const QUALITY = 0.82;

// Reduz a foto no próprio dispositivo antes do upload (evita travar o navegador no celular).
export async function compressPhoto(file) {
  if (!file || !file.type?.startsWith('image/')) return file;
  if (/heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name || '')) return file;
  if (file.size < 400 * 1024) return file;
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_DIM / Math.max(bitmap.width, bitmap.height));
    const w = Math.round(bitmap.width * scale);
    const h = Math.round(bitmap.height * scale);
    const canvas = document.createElement('canvas');
    canvas.width = w; canvas.height = h;
    canvas.getContext('2d').drawImage(bitmap, 0, 0, w, h);
    bitmap.close?.();
    const blob = await new Promise((res) => canvas.toBlob(res, 'image/jpeg', QUALITY));
    canvas.width = 0; canvas.height = 0;
    if (!blob || blob.size >= file.size) return file;
    const name = (file.name || 'foto').replace(/\.[^.]+$/, '') + '.jpg';
    return new File([blob], name, { type: 'image/jpeg' });
  } catch {
    return file;
  }
}

const CONCURRENCY = 3;

// Envia várias fotos com compressão no aparelho, 3 em paralelo e uma nova tentativa em caso de falha.
export async function uploadPhotoBatch(api, url, files, onProgress) {
  const list = Array.from(files || []);
  const total = list.length;
  const failed = [];
  let done = 0;
  let ok = 0;
  onProgress && onProgress({ done: 0, total, ok: 0 });

  const sendOne = async (file) => {
    const prepared = await compressPhoto(file);
    for (let attempt = 0; attempt < 2; attempt += 1) {
      try {
        const fd = new FormData();
        fd.append('file', prepared, prepared.name || file.name);
        await api.post(url, fd, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000 });
        ok += 1;
        return;
      } catch (e) {
        const detail = e.response?.data?.detail;
        const retryable = !e.response || e.code === 'ECONNABORTED' || e.response.status >= 500;
        if (attempt === 1 || !retryable) {
          failed.push({ name: file.name, reason: detail || (e.response ? `Erro ${e.response.status}` : 'Conexão interrompida') });
          return;
        }
        await new Promise((r) => setTimeout(r, 900));
      }
    }
  };

  const queue = [...list];
  const workers = Array.from({ length: Math.min(CONCURRENCY, queue.length) }, async () => {
    while (queue.length) {
      const file = queue.shift();
      await sendOne(file);
      done += 1;
      onProgress && onProgress({ done, total, ok });
    }
  });
  await Promise.all(workers);
  return { ok, failed };
}
